export const dataSaftey = "Here's more information that the developer has provided about the kinds of data that this app may collect and share, and security practices that the app may follow. Data practices may vary based on your app version, use, region and age."

export const dataSharing = "The developer says that this app doesn't share user data with other companies or organisations. Learn more about how developers declare sharing."

export const dataCollectionInfo = "Data that this app may collect"

export const userDataCollection = [
    { name :"Location", 
      details: "Approximate location and Precise location",
      icon: "ni-location"
    },
    { name :"Personal info",
      details:  "Name, Email address, Address, Phone number and Other info",
      icon: "ni-user"
    },
    { name: "Financial info",
      details: "Credit score and Other financial info",
      icon: "ni-master-card"
    },
    { name: "Messages",
      details: "SMS or MMS",
      icon: 'ni-emails'
    },
    { name: "Photos and videos",
      details: "Photos and Videos",
      icon: "ni-file-img"
    },
    { name: "Files and docs",
      details: "Files and docs",
      icon: "ni-file-doc"
    },
    { name: "Contacts",
      details: "Contacts",
      icon: "ni-contact"
    },
    { name: "App activity ",
      details: "App interactions and In-app search history",
      icon: "ni-activity-alt"
    },
    { name: "App info and performance",
      details: "Crash logs and Diagnostics",
      icon: "ni-activity"
    },
    { name: "Device or other IDs",
      details: "Device or other IDs",
      icon: "ni-mobile"
    }
]

export const dataSecurity = [
    { name: "Data is encrypted in transit",
      details: "Your data is transferred over a secure connection",
      icon: "lock"
    },
    { name: "Data can’t be deleted",
      details: "The developer doesn’t provide a way for you to request that your data be deleted",    
      icon: 'minus' 
    }
]